<template>
 
    <div class="col-12 backgroundForm">
        <div class="col-12 col-md-10 offset-md-1">
            <div class="alert alert-success" role="alert">
                <h4 class="alert-heading">Matrículas Pendientes de Aprobación</h4>
                <hr>
            </div>
            <form @submit.prevent="mCallBoatsPending">
                <div class="form-group"> 
                    <label for="nombreEmbarcacion">Seleccione el Puerto</label>
                    <select class="form-control" name="bandera_embarcacion" v-model="d_port">
                        <option v-for="port in d_ports" :value="port" :key="port.id">{{ port.name_port }}</option>
                    </select>
                    <small id="enrollmentHelp" class="form-text text-muted">Seleccione una opcion </small>
                </div>
                <button class="btn btn-sm btn-outline-primary col col-md-4 offset-md-4" >Listar <font-awesome-icon icon="list" size="sm" /></button>
            </form>
        </div>
        <br><br>
        <transition name="fade" mode="out-in">
        <div class="col-12 table-responsive" v-if="d_v_port">
            <table class="table table-striped">
                <thead class="thead-dark">
                    <tr>
                        <th scoped="col">#</th>
                        <th scoped="col">Nombre Embarcacion</th>
                        <th scoped="col">Tipo</th>
                        <th scoped="col">Propulsion</th>
                        <th scoped="col">Solicitud</th>
                        <th scoped="col">Abrir</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(boat, index) in d_boats_pending" :key="boat.id">
                        <td>{{ index+1 }}</td>
                        <td>{{ boat.nombre }}</td>
                        <td>{{ boat.detail_boat }}</td>
                        <td>{{ boat.propulsion_boat }}</td>
                        <td>{{ boat.correlativo }}/{{ boat.anio }}</td>
                        <td><button class="btn btn-outline-warning" @click="mGetRequestBoat(boat)"><font-awesome-icon icon="folder-open" /> Abrir</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        </transition>
    </div>
    
</template>
<script>

import Vue from 'vue';
import axios from 'axios';
const qs= require('qs');
import AdminMatriculacion from './AdminMatriculacion';

export default {
    name:'approv-matriculacion',
    data(){
        return{
            d_port:null,
            d_v_port:false,
            d_ports:[],
            d_boats_pending:[]
        }
    },
    mounted(){
        this.mCallPorts()
    },
    methods:{
        mCallPorts(){
            // axios.get(`getPorts`)
            axios.get(`getPorts?api_token=${Vue.auth.getToken()}`)
                .then((res) => {                    
                    this.d_ports = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })
        },
        mCallBoatsPending(){
            this.d_v_port=false;
            // axios.get(`getBoatsPending/${this.d_port.id}`)
            axios.get(`getBoatsPending/${this.d_port.id}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {                    
                    if(res.data.length > 0){
                        this.d_boats_pending = res.data
                        this.d_v_port=true;
                    }else{
                        toastr.info('No existen Solicitudes de Matriculacion', 'Nota')
                    }                    
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })
        },
        mGetRequestBoat(data){
            this.$store.dispatch('sShipEnrollmentP/addShipPendingEnrollment', data);
            this.$store.dispatch('sAuxShipEnrollmentP/addAuxShipPendingEnrollment', data);
            this.$router.push('admin-approved');
        }
    },
    computed:{
        c_boat_pending(){
            return this.d_boat_pending;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/matriculacion/ApprovMatriculacion.vue